import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFlashMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/use-flash-message";
import { useModalStore } from "@/stores/modal-store";
import { ApiWriteResponse } from "@/TS/Interfaces/global_interfaces";
interface AbsenceData {
  reason: string;
}
interface MutationParams {
  data: AbsenceData;
  type: string;
  clubSlug: string;
  startDate: string;
}

/**
 * Custom hook to handle absence mutation with refetch capability
 *
 * @param handleFetch - Function passed down from MonthCalender component to manually refetch events
 * @param setShouldRefresh - Function to trigger a refresh in the parent component
 */
export const useAbsenceMutation = (handleFetch, setShouldRefresh) => {
  const $ = _c(13);
  const {
    close
  } = useModalStore();
  const queryClient = useQueryClient();
  const {
    showFlashMessage
  } = useFlashMessage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["absence"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== close || $[2] !== handleFetch || $[3] !== queryClient || $[4] !== setShouldRefresh || $[5] !== showFlashMessage) {
    t1 = async (_, variables) => {
      if (setShouldRefresh) {
        setShouldRefresh(true);
      } else {
        ;
        try {
          await handleFetch();
        } catch (t2) {
          const error = t2;
          console.error("Error during handleFetch:", error);
        }
      }
      const queryToInvalidate = ["clubEvent", variables.type, variables.clubSlug, variables.startDate?.split("T")[0]];
      await queryClient.invalidateQueries({
        queryKey: queryToInvalidate,
        exact: true,
        refetchType: "all"
      });
      await queryClient.refetchQueries({
        queryKey: queryToInvalidate,
        exact: true,
        type: "all"
      });
      showFlashMessage("Vous avez notifi\xE9 votre absence \xE0 la r\xE9union. Le Pr\xE9sident du Club d'Affaires en a \xE9t\xE9 inform\xE9.", "success2", "mes-clubs-calendar");
      close();
    };
    $[1] = close;
    $[2] = handleFetch;
    $[3] = queryClient;
    $[4] = setShouldRefresh;
    $[5] = showFlashMessage;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== close || $[8] !== showFlashMessage) {
    t2 = error_0 => {
      close();
      showFlashMessage(error_0.message || "Une erreur est survenue lors de l'enregistrement de l'absence", "primary", "mes-clubs-calendar");
    };
    $[7] = close;
    $[8] = showFlashMessage;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = {
      mutationKey: t0,
      mutationFn: _temp2,
      onSuccess: t1,
      onError: t2
    };
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return useMutation(t3);
};
function _temp() {
  return {};
}
async function _temp2(t0) {
  const {
    data,
    type,
    clubSlug,
    startDate
  } = t0;
  const response = await fetch("/api/reason", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      ...data,
      type,
      clubSlug,
      startDate
    })
  });
  if (!response.ok) {
    const responseData = await response.json().catch(_temp);
    throw new Error(responseData.message || "Une erreur est survenue");
  }
  return response.json();
}